import { AuthorFields, calcDateSpanDescription, Document, FullAuthored } from 'model';
import { ProfilePic } from '../components/ProfilePic';
// eslint-disable-next-line css-modules/no-unused-class
import shareStyles from '../styles/Shared.module.css';
import styles from './AuthorHeaderSmall.module.css';

export const AuthorHeaderSmall = <T extends Document & AuthorFields>({
	authoredItem,
	testId
}: {
	authoredItem: FullAuthored<T>;
	testId?: string;
}): ReturnType<React.FC<{ author: FullAuthored<T> }>> => {
	return (
		<>
			<ProfilePic user={authoredItem.fullAuthor} size={'tiny'} />
			<div className={styles.headerContainer}>
				<div className={styles.userNameSmall} data-testid={testId}>
					{authoredItem && authoredItem.author && authoredItem.fullAuthor.username}
				</div>

				<span className={shareStyles.time}>{calcDateSpanDescription(authoredItem.updated)}</span>
			</div>
		</>
	);
};
